import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
    // flat alap: nincs rounded, nincs shadow
    "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
    {
        variants: {
            variant: {
                default:     "bg-za-dark text-white hover:bg-za-deep",
                destructive: "bg-za-warning text-white hover:opacity-90",
                outline:     "border border-za-mid bg-transparent text-za-text hover:bg-za-hover",
                secondary:   "bg-za-hover text-za-text hover:bg-za-border",
                ghost:       "text-za-muted hover:bg-za-hover hover:text-za-text",
                link:        "text-za-dark underline-offset-4 hover:underline",
                white:       "bg-white text-za-text border border-za-border hover:bg-za-hover",
            },
            size: {
                default: "h-9 px-4 py-2",
                sm:      "h-7 px-3 text-xs",
                lg:      "h-10 px-6",
                icon:    "h-9 w-9",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
)

export interface ButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> { }

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, variant, size, ...props }, ref) => {
        return (
            <button
                className={cn(buttonVariants({ variant, size, className }))}
                ref={ref}
                {...props}
            />
        )
    }
)
Button.displayName = "Button"

export { Button, buttonVariants }
